module.exports = __webpack_public_path__ + "img/24.7397b3a5.jpg";